import Vue from 'vue';

const state = {
    cart: {
        itemCount: 0,
        shippingCost: 0,
        shippingAddress: null,
        billingAddress: null,
        pickUpLocation: null,
        shippingMethod: null // handle
    },
    currentStep: 1
}

const actions = {
    async loadCart({ commit }) {
        return await window.axios({
            url: '/actions/checkout-module/order/get-cart',
            method: 'GET'
        }).then(result => {
            if (result.status === 200 && result?.data) {
                // Update cart count to show in navigation
                commit("LOAD_CART", result.data);
                return { success: true, data: result };
            } else {
                console.warn('Could not retrieve cart.', result);
                return { success: false, data: result };
            }
        }).catch(error => {
            console.warn('Could not connect to controller.', error);
            return { success: false, data: error };
        });
    },
    
    updateCart({ commit }, payload) {
        commit('UPDATE_CART', payload);
    },
    
    updateCurrentStep({ commit }, step) {
        commit('UPDATE_CURRENT_STEP', step);
    },
    
    updateShippingMethod({ commit }, method) {
        commit('UPDATE_SHIPPING_METHOD', method);
    },
    
    clearCart({ commit }) {
        commit('CLEAR_CART');
    }
}

const mutations = {
    LOAD_CART(state, cart) {
        state.cart = { ...state.cart, ...cart };
    },
    
    UPDATE_CART(state, { key, value }) {
        Vue.set(state.cart, key, value);
    },
    
    UPDATE_SHIPPING_METHOD(state, method) {
        Vue.set(state.cart, 'shippingMethod', method);
    },
    
    UPDATE_CURRENT_STEP(state, step) {
        state.currentStep = step;
    },
    
    CLEAR_CART(state) {
        state.cart.shippingAddress = null;
        state.cart.billingAddress = null;
        state.cart.pickUpLocation = null;
        state.cart.shippingMethod = null; // handle
    }
}

const getters = {
    getCart(state) {
        return state.cart;
    },
    
    getCartSkus(state) {
        if (state.cart.lineItems && state.cart.lineItems.length > 0) {
            return state.cart.lineItems.map(i => i.sku);
        }
        return [];
    },
    
    getShippingMethod(state) {
        return state.cart.shippingMethod;
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
